import Hero from './sections/Hero';
import About from './sections/About';
import Projects from './sections/Projects';
import Experience from './sections/Experience';
import Education from './sections/Education';
import Skills from './sections/Skills';
import Blog from './sections/Blog';
import Contact from './sections/Contact';

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Education />
      <Skills />
      <Blog />
      <Contact />
    </>
  );
}
